import React, { useEffect, useState } from 'react'

const STORAGE_KEY = 'dorac-cookie-consent'

function CookieConsent() {
  const [mounted, setMounted] = useState(false)
  const [shown, setShown] = useState(false)

  useEffect(() => {
    const consent = window.localStorage.getItem(STORAGE_KEY)
    if (!consent) {
      setMounted(true)
      const timer = setTimeout(() => setShown(true), 2000)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleAccept = () => {
    window.localStorage.setItem(STORAGE_KEY, 'accepted')
    setShown(false)
    setTimeout(() => setMounted(false), 500)
  }

  if (!mounted) return null

  return (
    <div className='pointer-events-none fixed bottom-0 left-0 right-0 z-[100] p-4'>
      <div
        className='pointer-events-auto mx-auto flex max-w-3xl flex-col items-center gap-4 rounded-2xl p-5 transition-all duration-500 ease-out sm:flex-row'
        style={{
          background: '#000000',
          boxShadow: '0 12px 30px rgba(0,0,0,0.35)',
          opacity: shown ? 1 : 0,
          transform: shown ? 'translateY(0)' : 'translateY(24px)',
        }}
      >
        <p className='flex-1 text-sm leading-relaxed text-white/80'>
          Usamos cookies para melhorar sua experiência no site. Ao continuar navegando, você concorda com nossa{' '}
          <a href='#/politica-de-privacidade' className='font-semibold text-white underline'>
            Política de Privacidade
          </a>{' '}
          e nossos{' '}
          <a href='#/termos-de-uso' className='font-semibold text-white underline'>
            Termos de Uso
          </a>
          .
        </p>
        <button onClick={handleAccept} className='btn-dorac flex-shrink-0 whitespace-nowrap px-6 py-3 text-sm'>
          Aceitar e continuar
        </button>
      </div>
    </div>
  )
}

export default CookieConsent
